import React, { Component } from 'react';
import WorldMap from './WorldMap';
import { getCountryStats } from '../redux/selectors';
import { connect } from 'react-redux';
import { getSelectedJurisdictionCode } from '../../../../jurisdiction/redux/selectors';
import { TrafficAndAlertStatsContainer } from './TrafficAndAlertStatsContainer';
import { Flag } from '../../../../shared/jurisdiction-select/JurisdictionSelect';
import * as _ from 'lodash';
import { setJurisdictionByCode } from '../../../../jurisdiction/redux/actions';
import { allJurisdictionsCode } from '../../../../shared/models/jurisdictions';

class GeographicalInsight extends Component {
    constructor(props) {
        super(props);
        this.state = {
            countriesData: []
        };
    }

    componentDidMount() {
        // todo [mandy]: get these from the backend
        this.setState({ countriesData: countriesData });
    }

    handleMarkerClick(countryCode) {
        this.props.setJurisdictionByCode(countryCode);
    }

    getAlertsLastHour = countryCode => {
        return (
            this.props.countriesStats &&
            this.props.countriesStats[countryCode] &&
            this.props.countriesStats[countryCode].alertsLastHour
        );
    };

    getTrafficLastHour = countryCode => {
        return (
            this.props.countriesStats &&
            this.props.countriesStats[countryCode] &&
            this.props.countriesStats[countryCode].trafficLastHour
        );
    };

    render() {
        const {
            selectedCountryCode,
            trafficTooltipMessage,
            alertsTooltipMessage
        } = this.props;

        const countryCode = selectedCountryCode || allJurisdictionsCode;

        return (
            <div style={{ display: 'flex', flexDirection: 'row' }}>
                <div style={{ flex: countryCode ? '80%' : '100%' }}>
                    <WorldMap
                        chosenCountry={countryCode}
                        countriesData={this.state.countriesData}
                        handleMarkerClick={this.handleMarkerClick.bind(this)}
                    />
                </div>
                <div
                    style={{
                        flex: '20%',
                        display: 'flex',
                        alignItems: 'center'
                    }}
                >
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            width: '100%'
                        }}
                    >
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                marginBottom: '31px'
                            }}
                        >
                            <span
                                style={{
                                    color: 'var(--dark-gray',
                                    fontSize: '14px',
                                    fontWeight: '500',
                                    marginBottom: '12px'
                                }}
                            >
                                Country
                            </span>
                            <span
                                style={{
                                    color: 'var(--black)',
                                    fontSize: '32px',
                                    fontWeight: '700'
                                }}
                            >
                                <span>
                                    <span style={{ marginRight: '5px' }}>
                                        {_.capitalize(countryCode)}
                                    </span>
                                    <div
                                        style={{
                                            width: 25,
                                            paddingLeft: '8px',
                                            display: 'inline-block'
                                        }}
                                    >
                                        <Flag
                                            isoCode={countryCode}
                                            className={'flag'}
                                        />
                                    </div>

                                    {/*<Flag*/}
                                    {/*    width={25}*/}
                                    {/*    height={17}*/}
                                    {/*    name={countryCode.toLocaleLowerCase()}*/}
                                    {/*    format="svg"*/}
                                    {/*    shiny={true}*/}
                                    {/*    basePath="/img/flags"*/}
                                    {/*/>*/}
                                </span>
                            </span>
                        </div>
                        <TrafficAndAlertStatsContainer
                            trafficLastHour={this.getTrafficLastHour(
                                countryCode
                            )}
                            trafficTooltipMessage={trafficTooltipMessage}
                            alertsLastHour={this.getAlertsLastHour(countryCode)}
                            alertsTooltipMessage={alertsTooltipMessage}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    const countriesStats = getCountryStats(state);
    const selectedCountryCode = getSelectedJurisdictionCode(state);

    return {
        countriesStats,
        selectedCountryCode
    };
};

const mapDispatchToProps = dispatch => ({
    setJurisdictionByCode: jurisdiction =>
        dispatch(setJurisdictionByCode(jurisdiction))
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(GeographicalInsight);

let countriesData = [
    {
        country: 'United Kingdom',
        countryCode: 'GB', // ISO 3166-1 Alpha 2
        coordinates: {
            lat: 55.3781,
            lon: 3.436
        },
        traffic: 104,
        alerts: 48
    },
    {
        country: 'Malta',
        countryCode: 'MT',
        coordinates: {
            lat: 35.898907,
            lon: 14.514553
        },
        traffic: 78,
        alerts: 34
    },
    {
        country: 'Sweden',
        countryCode: 'SE',
        coordinates: {
            lat: 59.33279,
            lon: 18.064489
        },
        traffic: 290,
        alerts: 90
    }
];
